export const DEFAULT_ESCROW_PAGE = 'DEFAULT_ESCROW_PAGE';
export const MAIN_FUNNEL_PAGE = 'MAIN_FUNNEL_PAGE';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
